import React from "react";

const BS5_Offcanvas = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Offcanvas Component</h2>
      <p>This is the BS5_Offcanvas component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Offcanvas;
